import { connect } from 'react-redux'
import EkgReview from './EkgReview'
import { getDataSource } from '../../store/appReducer'
import { DATASOURCES } from '../../constants'
import {
  getEkgReviewData,
  handleOnFilterButtonClick,
  handleOnEKGNextClick,
  handleOnSortClick,
  handleOnFilterChange,
  handleOnTabClick,
  handleOnPhysicianInboxChange,
  handleOnRowClick,
  getRecordingIdsFromDataSource,
  handleOnRefreshClick,
  handleOnBulkAction,
  handleOnBulkActionTriggerModal,
  handleOnBulkActionCloseModal,
  updateSelectedEkgs,
  handleOnSelectionClick,
  handleOnConfirmedMonthClick,
} from './module'
import { setNSRStatus } from 'views/state/ProfileSettings/ProfileSettingsActions'

const mapActionCreators = {
  getEkgReviewData,
  handleOnFilterButtonClick,
  handleOnEKGNextClick,
  handleOnSortClick,
  handleOnFilterChange,
  handleOnTabClick,
  handleOnPhysicianInboxChange,
  handleOnRowClick,
  handleOnRefreshClick,
  handleOnBulkAction,
  handleOnBulkActionTriggerModal,
  handleOnBulkActionCloseModal,
  updateSelectedEkgs,
  handleOnSelectionClick,
  handleOnConfirmedMonthClick,
  setNSRStatus,
}

const mapStateToProps = state => ({
  dataIsFetching: state.ekgReview.dataIsFetching,
  dataLastUpdated: state.ekgReview.dataLastUpdated,
  refreshClicked: state.ekgReview.refreshClicked,
  bulkActionComplete: state.ekgReview.bulkActionComplete,
  bulkActionIsFetching: state.ekgReview.bulkActionIsFetching,
  bulkActionSuccessMessage: state.ekgReview.bulkActionSuccessMessage,
  selectedIndex: state.ekgReview.selectedIndex,
  selectedPageTab: state.ekgReview.selectedPageTab,
  selectedInboxId: state.ekgReview.selectedInboxId,
  selectedPatientId: state.ekgReview.selectedPatientId,
  selectedCustomColumnId: state.ekgReview.selectedCustomColumnId,
  selectedEkgResult: state.ekgReview.selectedEkgResult,
  selectedPhysicianId: state.ekgReview.selectedPhysicianId,
  selectedPhysicians: state.ekgReview.selectedPhysicians,
  selectedStartDate: state.ekgReview.selectedStartDate,
  selectedEndDate: state.ekgReview.selectedEndDate,
  selectedBpmStartValue: state.ekgReview.selectedBpmStartValue,
  selectedBpmEndValue: state.ekgReview.selectedBpmEndValue,
  selectedConfirmedCurrentMonth: state.ekgReview.selectedConfirmedCurrentMonth,
  selectedPopover: state.ekgReview.selectedPopover,
  selectedEkgs: state.ekgReview.selectedEkgs,
  stackNextResultsToken: state.ekgReview.stackNextResultsToken,
  me: getDataSource(state, DATASOURCES.ME),
  ekgs: getDataSource(state, DATASOURCES.EKGS),
  ekgStacks: getDataSource(state, DATASOURCES.EKG_STACKS),
  patients: getDataSource(state, DATASOURCES.PATIENTS),
  physicians: getDataSource(state, DATASOURCES.PHYSICIANS),
  ekgStackCounts: getDataSource(state, DATASOURCES.EKG_STACK_COUNTS),

  recordingIds: getRecordingIdsFromDataSource(state),
  sortBy: state.ekgReview.sortBy,
  sortDirection: state.ekgReview.sortDirection,
})

export default connect(
  mapStateToProps,
  mapActionCreators
)(EkgReview)



// WEBPACK FOOTER //
// ./src/legacy/pages/EkgReview/container.js